var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups__Type=Groups",
    className: "groups__Type=Groups"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groups__Group 38837",
    className: "groups__Group groups__38837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "groups__Vector",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.108 4.405a3.134 3.134 0 1 0 0 6.268 3.134 3.134 0 0 0 0-6.268ZM4.528 7.54a4.58 4.58 0 1 1 9.16 0 4.58 4.58 0 0 1-9.16 0Zm9.74-3.858c0-.4.323-.723.723-.723a4.58 4.58 0 1 1 0 9.16.723.723 0 0 1 0-1.446 3.134 3.134 0 1 0 0-6.268.723.723 0 0 1-.723-.723Zm2.441 10.678a.723.723 0 0 1 .924-.438c2.088.748 3.381 1.855 4.196 3.14.8 1.265 1.1 2.645 1.306 3.854a.723.723 0 0 1-.713.844h-3.154a.723.723 0 1 1 0-1.446h2.28c-.188-.874-.457-1.713-.941-2.477-.625-.986-1.645-1.903-3.461-2.553a.723.723 0 0 1-.437-.925ZM2.978 16.48c1.385-1.572 3.482-2.928 6.25-2.928h.012c2.948.052 4.947 1.295 6.22 2.852 1.253 1.532 1.787 3.342 1.897 4.569a.723.723 0 0 1-.72.788H1.579a.723.723 0 0 1-.724-.724c0-.607.206-1.368.554-2.139a9.797 9.797 0 0 1 1.57-2.418Zm-.555 3.834h13.365a7.415 7.415 0 0 0-1.447-2.994c-1.018-1.245-2.623-2.276-5.12-2.322-2.25.003-3.975 1.096-5.158 2.438a8.354 8.354 0 0 0-1.336 2.056 5.958 5.958 0 0 0-.304.822Z",
    className: "groups__Vector",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.c68873b32c1cc7adf8d8ca0c49da4465.svg";
export { ForwardRef as ReactComponent };